// src/aws-config.ts
import { Amplify, type ResourcesConfig } from 'aws-amplify';
import { IS_LOCAL_FLOCI } from '../utils/localFloci';

// `--mode floci` only: Cognito calls go through Vite's /floci-proxy (see vite.config.ts).
const useFloci = IS_LOCAL_FLOCI;

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env['VITE_ADMIN_COGNITO_USER_POOL_ID'],
      userPoolClientId: import.meta.env['VITE_ADMIN_COGNITO_CLIENT_ID'],
      ...(useFloci
        ? { userPoolEndpoint: `${window.location.origin}/floci-proxy` }
        : {}),
    },
  },
};

Amplify.configure(amplifyConfig);
